<template>
  <section>
    <div class="container">
      <div>
        <div class="content">
          <h2>Our Team</h2>
          <p>
            <a href="/our-team#founder">Founder/CEO</a><br>
            <a href="/our-team#trusteeBoard">UK Trustee Board</a><br>
            <a href="/our-team#missionSponsors">Mission Sponsors</a><br>
            <a href="/our-team#corporateSponsors">Corporate Sponsors</a><br>
            <a href="/our-team#thank-you">Thank You</a><br>
          </p>
          <router-link to="/our-team" class="btn btn-lg btn-primary">Meet Our Team</router-link>
        </div>
        <div class="image">
          <img src="~assets/images/PFK_Photo3_OurTeam_810x370.jpg" width="810" height="370">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'our-team'
}
</script>

<style lang="scss" scoped>
  @import '~assets/styles/vars';

  section {
    display: flex;
    background: $gold;
    .container {
      @extend %noPadContainer;
      > div {
        display: flex;
        flex-direction: column-reverse;
        @include media('tablet-wide') {
          flex-direction: row;
          align-items: center;
        }
        .content {
          flex: 1;
          text-align: center;
          padding: 30px;
          @include media('tablet-wide') {
            padding: 0
          }
          p {
            font-size: 0.8rem;
            @include media('desktop') {
              font-size: 1rem;
            }
          }
        }
        .image {
          img {
            width: 100%;
            height: auto;
            @include media('tablet-wide') {
              width: 660px;
            }
            @include media('desktop') {
              width: 810px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// OurTeam.vue?88ba73ea